import LanguageLocale from 'utils/LanguageLocale';

const isChatEnabledFlag = () => {
    let isChatEnabled = false;

    if (LanguageLocale.isFRCanada()) {
        isChatEnabled = !!Sephora.configurationSettings.gladChatConfig?.isCAFREnabled;
    } else if (LanguageLocale.isCanada()) {
        isChatEnabled = !!Sephora.configurationSettings.gladChatConfig?.isCAEnglishEnabled;
    } else {
        isChatEnabled = !!Sephora.configurationSettings.isChatEnabled;
    }

    return isChatEnabled;
};

const getAppId = () => {
    let selectedAppId = null;

    if (LanguageLocale.isFRCanada()) {
        selectedAppId = Sephora.configurationSettings.gladChatConfig?.appIdCAFR;
    } else if (LanguageLocale.isCanada()) {
        selectedAppId = Sephora.configurationSettings.gladChatConfig?.appIdCAEN;
    } else {
        selectedAppId = Sephora.configurationSettings.gladChatConfig?.appId;
    }

    return selectedAppId;
};

const getTimer = () => {
    let timer = 0;

    if (LanguageLocale.isFRCanada()) {
        timer = Sephora.configurationSettings.gladChatConfig?.timerCAFR || 0;
    } else if (LanguageLocale.isCanada()) {
        timer = Sephora.configurationSettings.gladChatConfig?.timerCAEN || 0;
    } else {
        timer = Sephora.configurationSettings.gladChatConfig?.timer || 0;
    }

    return timer;
};

const gladAppisNotMinimized = () => {
    const selectedAppId = getAppId();
    const data = JSON.parse(localStorage.getItem(selectedAppId) || '{}');

    return data?.values?.isMinimized === false;
};

export default {
    isChatEnabledFlag,
    getAppId,
    getTimer,
    gladAppisNotMinimized
};
